import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import { chinaContract } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";
import { getTxGasConfig } from "../getTxGasConfig";

const usePurchaseUsdc = () => {
  const { account } = useWeb3React();
  const web3 = useWeb3();
  const tokenAddress = Environment.presaleContract;
  const contract = chinaContract(tokenAddress, web3);
  const UsdcAddress = Environment.usdc;

  const purchaseUsdc = useCallback(
    async (
      amount,
      postApiRes,
      id,
      balance,
      min,
      stakeIndex,
      index,
      insurancePer,
    ) => {
      if (!account) throw new Error("WALLET_NOT_CONNECTED");

      // Amount with insurance if index is true
      let nd = 0;
      if (index) {
        let percent = parseFloat(amount) * insurancePer;
        let value = parseFloat(amount) + percent;
        let rounded = Math.round(parseFloat(value).toFixed(6) * 1e12) / 1e12;
        nd = web3.utils.toWei(rounded.toString(), "mwei");
      } else {
        let rounded = Math.round(parseFloat(amount).toFixed(6) * 1e12) / 1e12;
        nd = web3.utils.toWei(rounded.toString(), "mwei");
      }

      // Minimum value for slippage
      let minvalue =
        Math.round((parseFloat(min) * 0.99).toFixed(6) * 1e12) / 1e12;
      minvalue = web3.utils.toWei(minvalue.toString(), "ether");
      console.log(
        "│ Initiating purchase with USDT:",
        JSON.stringify(
          {
            UsdcAddress,
            normalizationFactor: postApiRes?.normalizationFactor,
            price: postApiRes?.price,
            nd,
            minvalue,
            agentsAddresses: postApiRes?.agentsAddresses,
            agentsPercentages: postApiRes?.agentsPercentages,
            code: postApiRes?.code,
            id,
            deadline: postApiRes?.deadline,
            v: postApiRes?.v,
            r: postApiRes?.r,
            s: postApiRes?.s,
          },
          null,
          2,
        ),
      );

      try {
        return new Promise(async (resolve, reject) => {
          let gas;
          try {
            gas = await contract.methods
              .purchaseTokenWithToken(
                UsdcAddress,
                postApiRes?.normalizationFactor,
                postApiRes?.price,
                nd,
                minvalue,
                postApiRes?.agentsAddresses,
                postApiRes?.agentsPercentages,
                postApiRes.code,
                id,
                postApiRes.deadline,
                postApiRes?.v,
                postApiRes?.r,
                postApiRes?.s,
              )
              .estimateGas({ from: account });
          } catch (err) {
            console.error("Gas estimation failed:", err);
            return reject(err);
          }

          const gasLimit = Math.floor(gas * 1.2);

          const gasConfig = await getTxGasConfig(web3, "42161", account);

          contract.methods
            .purchaseTokenWithToken(
              UsdcAddress,
              postApiRes?.normalizationFactor,
              postApiRes?.price,
              nd,
              minvalue,
              postApiRes?.agentsAddresses,
              postApiRes?.agentsPercentages,
              postApiRes.code,
              id,
              postApiRes.deadline,
              postApiRes?.v,
              postApiRes?.r,
              postApiRes?.s,
            )
            .send({ from: account, gas: gasLimit, ...gasConfig })
            .on("transactionHash", (hash) => {
              console.log("USDC tx hash:", hash);
            })
            .on("receipt", (receipt) => {
              console.log("USDC purchase confirmed:", receipt);
              resolve({ transactionHash: receipt.transactionHash, receipt });
            })
            .on("error", (error) => {
              console.error("USDC purchase error:", error);
              reject(error);
            });
        });
      } catch (error) {
        throw error;
      }
    },
    [account, contract, web3],
  );

  return { purchaseUsdc };
};

export default usePurchaseUsdc;

// import { useCallback, useState } from "react";
// import useWeb3 from "../useWeb3";
// import { chinaContract } from "../../utils/contractHelpers";
// import { useWeb3React } from "@web3-react/core";
// import Environment from "../../utils/Environment";
// import { toast } from "react-toastify";

// const PurchaseUsdc = () => {
//   const { account } = useWeb3React();
//   const web3 = useWeb3();
//   const UsdtAdress = Environment.usdc;
//   const priceUsdt = 10000;
//   const tokenAddress = Environment.presaleContract;
//   const contract = chinaContract(tokenAddress, web3);
//   const purchaseUsdc = useCallback(
//     async (
//       amount,
//       postApiRes,
//       id,
//       balance,
//       min,
//       stakeIndex,
//       index,
//       insurancePer
//     ) => {
//       let nd = 0;
//       if (index) {
//         let percecnt = parseFloat(amount) * insurancePer;
//         let value = parseFloat(amount) + percecnt;
//         let valuess = parseFloat(value).toFixed(6);
//         let amount1 = Math.round(valuess * 1e12) / 1e12;
//         nd = web3.utils.toWei(amount1.toString(), "mwei");
//       } else {
//         let valuess = parseFloat(amount).toFixed(6);
//         let amount1 = Math.round(valuess * 1e12) / 1e12;
//         nd = web3.utils.toWei(amount1.toString(), "mwei");
//       }
//       let minvalue = min * 0.99;
//       minvalue = parseFloat(minvalue).toFixed(6);
//       minvalue = Math.round(minvalue * 1e12) / 1e12;
//       // console.log(minvalue,'minvalue');
//       minvalue = web3.utils.toWei(minvalue.toString(), "ether");

//       // console.log(postApiRes?.factorNormalization,UsdtAdress,priceUsdt.toString(),minvalue,postApiRes.code,id,postApiRes.deadline, postApiRes?.v, postApiRes?.r, postApiRes?.s,' nd,postApiRes.code,id,postApiRes.deadline,postApiRes?.v, postApiRes?.r, postApiRes?.s');
//       //     let tuple = {
//       //       postApiRes.code:postApiRes.postApiRes.code,
//       //       GodAgentPercentage:postApiRes.gotAgentPercentage,
//       //       MegaAgentPercentage:postApiRes.megaAgentPercentage,
//       //       SuperAgentPercentage:postApiRes.superAgentPercentage,
//       //       AgentPercentage:postApiRes.agentPercentage,
//       //       GodAgentAddress:postApiRes.gotAgentAddress,
//       //       MegaAgentAddress:postApiRes.megaAgentAddress,
//       //       SuperAgentAddress:postApiRes.superAgentAddress,
//       //       AgentAddress:postApiRes.agentAddress,
//       // };
//       let gas;
//       try {
//         let gasPrice = await web3.eth.getGasPrice();
//         gasPrice = parseInt(gasPrice) + 3000000000;
//         gas = await contract.methods
//           .purchaseTokenWithToken(
//             UsdtAdress,
//             postApiRes?.normalizationFactor,
//             postApiRes?.normalizationFactorNft,
//             postApiRes?.price,
//             nd,
//             minvalue,
//             stakeIndex,
//             postApiRes?.agentsAddresses,
//             postApiRes?.agentsPercentages,
//             // index,
//             postApiRes.code,
//             id,
//             postApiRes.deadline,
//             postApiRes?.v,
//             postApiRes?.r,
//             postApiRes?.s
//           )
//           .estimateGas({
//             from: account,
//             gasPrice,
//           });
//         const details = await contract.methods
//           .purchaseTokenWithToken(
//             UsdtAdress,
//             postApiRes?.normalizationFactor,
//             postApiRes?.normalizationFactorNft,
//             postApiRes?.price,
//             nd,
//             minvalue,
//             stakeIndex,
//             postApiRes?.agentsAddresses,
//             postApiRes?.agentsPercentages,
//             // index,
//             postApiRes.code,
//             id,
//             postApiRes.deadline,
//             postApiRes?.v,
//             postApiRes?.r,
//             postApiRes?.s
//           )
//           .send({
//             from: account,
//             gas: gas,
//             gasPrice,
//           });
//         return details;
//       } catch (error) {
//         // let gasPrice1=await web3.eth.getGasPrice()
//         // let gasPrice = parseInt(gasPrice1) + 3000000000
//         // gas=gas*gasPrice
//         // let nd = web3.utils.fromWei(gas.toString(), "ether");
//         // console.log(gas,nd,balance );
//         // if(nd>balance){
//         //    toast.error("Insufficient ETH for Transaction")
//         // }else{
//         throw error;
//         // }
//       }
//     },
//     [contract, account, web3]
//   );
//   return { purchaseUsdc: purchaseUsdc };
// };
// export default PurchaseUsdc;
